<template>
  <div class="container">
    <div class="header">
      <div class="header-avatar">
        <img :src="avatarUrl" :onerror="defaultAvartarUrl" alt="">
      </div>
      <div class="header-user">
        <div class="header-nickname" @click="goLogin">{{ nickname || '未登录' }}</div>
        <div class="header-userid" @click="goLogin">{{ userId ? 'ID：' + userId : '点击登录领取VIP' }}</div>
      </div>
    </div>
    <div class="gift">
      <div class="title">您的专属新人礼包</div>
      <div class="card">
        <transition name="fade"><span class="card-text" v-if="rewardDay.visible"><span v-show="rewardDay.showBefore">最高</span>{{ rewardDay.text }}</span></transition>
        <img src="@/assets/vip/get/get-card.png" alt="">
      </div>
      <div class="btn" @click="handleGetVip"><img :src="hasGetVip ? require('@/assets/vip/get/get-btn-got.png') : require('@/assets/vip/get/get-btn.png')" alt=""></div>
    </div>
    <div class="rights">
      <div class="title">会员权益</div>
      <div class="wrap more-rights">
        <div class="list">
          <div class="item">
            <img src="@/assets/vip/right-more-1.png" alt="" class="pic">
            <div class="info">
              <h2 class="item-title">会员故事畅听</h2>
              <p class="desc">VIP会员畅听，7000部、10万集有声作品。在有效期内可畅听：包含经典童话故事、大奖绘本、各类儿童故事、英语磨耳、英语知识、科普知识、必读名著、历史国学知识等。不仅听故事，还能学知识！</p>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/vip/right-more-2.png" alt="" class="pic">
            <div class="info">
              <h2 class="item-title">每月重磅作品</h2>
              <p class="desc">月均上新20部作品，知名IP不断引入，可听的内容不断扩充；每周精选VIP专题，不再选择焦虑。</p>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/vip/right-more-3.png" alt="" class="pic">
            <div class="info">
              <h2 class="item-title">非VIP内容折扣</h2>
              <p class="desc">由于内容提供方版权问题，我们有部分故事不属于VIP畅听内容，如果您需要听这些内容，口袋故事也为尊贵的VIP用户争取到单购折扣，最低可至5折。</p>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/vip/right-more-4.png" alt="" class="pic">
            <div class="info">
              <h2 class="item-title">VIP专享优惠</h2>
              <p class="desc">VIP除了VIP专享折扣之外，购买单购故事或VIP续期，都可以再叠加使用优惠券。</p>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/vip/right-more-5.png" alt="" class="pic">
            <div class="info">
              <h2 class="item-title">签到双倍贝壳</h2>
              <p class="desc">贝壳可以在口袋故事的兑换中心兑取小朋友们喜爱的故事机、儿童手表、书籍、文具、以及丰富的生活和学习用品。</p>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/vip/right-more-6.png" alt="" class="pic">
            <div class="info">
              <h2 class="item-title">1对1客户服务</h2>
              <p class="desc">会员尊贵服务：微信添加好友"koudai020"，为您解答所有使用过程中的困惑！</p>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/vip/right-more-7.png" alt="" class="pic">
            <div class="info">
              <h2 class="item-title">独家内容抢先听</h2>
              <p class="desc">口袋故事有1000多部正版独家作品，会员都可以畅听。</p>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/vip/right-more-8.png" alt="" class="pic">
            <div class="info">
              <h2 class="item-title">不定期福利</h2>
              <p class="desc">关注公众号“口袋故事福利社”，回复“充电”，即可获得价值495元的学习充电大礼包。内容包含古诗词、英语课、名著故事和父母课堂等内容。</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="qa" @click="goUserHelp">
      <span class="qa-text">会员常见问题</span>
      <img class="qa-icon" src="@/assets/global/arrow_right.png">
    </div>

    <!-- <div class="customer">
      <div class="customer-title">如有任何问题，请联系客服</div>
      <div class="customer-phone">
        <img src="@/assets/global/icon_phone.png" alt="">
        <span>客服电话：400-825-5211</span>
      </div>
      <div class="customer-wechat">
        <img src="@/assets/global/icon_wechat.png" alt="">
        <span>微信服务号：idaddy100</span>
      </div>
    </div> -->

    <div class="desc">
      <div class="title">活动说明：</div>
      <div class="text">1.本福利为手表和平板用户专享，首次使用手机App可领取；</div>
      <div class="text">2.每人可领取随机天数的VIP会员，最多可领取1个月VIP会员；</div>
      <div class="text">3.每人仅限领取1次</div>
      <div class="text">本活动解释权归口袋故事所有，如有疑问可咨询在线客服（家长页》帮助中心》在线客服）</div>
    </div>

    <div class="modal" v-show="modalVisible">
      <div class="modal-pic">
        <img src="@/assets/vip/get/get-card.png" alt="">
        <div class="modal-day">{{ rewardDay.text }}</div>
      </div>
      <div class="modal-title">恭喜您成功领取{{ rewardDay.text }}</div>
      <div class="modal-date">{{ vipExpiredDate }} VIP到期</div>
      <div class="modal-text">有效期内可畅听全场VIP精品内容</div>
      <div class="modal-btn" @click="goListen">开始畅听</div>
    </div>

    <div class="tips" v-show="tips.visible">{{ tips.text }}</div>

    <transition name="fade"><div class="mask" v-show="maskVisible"></div></transition>
  </div>
</template>

<script>
import moment from 'moment'
import store from '@/store/store'
import { mapGetters } from 'vuex'
import { login } from '@/utils/login'
import { sendTraceLog } from '@/api/trace'
import { getRule, getRewardStatus, getReward, getChannelRewardList } from '@/api/reward'

/**
 * wt1/正式环境配置数据
 * 渠道标识：watch-hd-new	(id：190)
 * 奖励id、奖励天数、中奖概率：
 * 104 3天vip 50%
 * 106 7天vip 25%
 * 108 14天vip 15%
 * 109 21天vip 7%
 * 110 30天vip 3%
 */

export default {
  name: 'Getvip',
  data () {
    return {
      rewardList: [],
      currentReward: {},
      rewardDay: {
        text: '30天VIP',
        visible: false,
        showBefore: true
      },
      probability: {
        '104': 50,
        '106': 25,
        '108': 15,
        '109': 7,
        '110': 3
      },
      lottery: [],
      hasGetVip: false,
      modalVisible: false,
      maskVisible: false,
      tips: { text: '您已经领取过了哦', visible: false },
      defaultAvartarUrl: 'this.src="' + require('@/assets/global/avatar.png') + '"'
    }
  },
  async created () {
    await this.getChannelRewardList()
    await this.getRewardStatus()
  },
  methods: {
    async getChannelRewardList () {
      try {
        let { list } = await getChannelRewardList(this.channelId, this.userId)
        this.rewardList = list || []
      } catch (e) {
        console.error(e)
      }
    },
    async getRewardStatus () {
      try {
        let data = await getRewardStatus(this.channelId, this.userId)
        if (+data.status === 1) {
          // 已领奖
          this.hasGetVip = true
          this.currentReward = this.rewardList.find(item => {
            return +item.reward_id === +data.reward_id
          }) || {}
          this.updateRewardDay()
          console.log('hasget', this.currentReward)
        } else {
          // 未领奖
          this.randomDrawPrize()
          console.log('noget', this.currentReward)
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.rewardDay.visible = true
      }
    },
    randomDrawPrize () {
      this.rewardList.forEach(reward => {
        if (this.probability[reward.reward_id]) {
          for (let i = 0; i < this.probability[reward.reward_id]; i++) {
            this.lottery.push(reward.reward_id)
          }
        }
      })
      this.lottery = this.shuffleArr(this.lottery)
      let n = Math.floor(Math.random() * this.lottery.length + 1) - 1
      this.currentReward = this.rewardList.find(item => {
        return +item.reward_id === +this.lottery[n]
      }) || {}
    },
    shuffleArr (arr = []) {
      let tempArr = arr.slice() || []
      let length = tempArr.length
      for (let i = 0; i < length; i++) {
          let index = parseInt(Math.random() * (length - i)) + i
          if (index != i) {
              let temp = tempArr[i]
              tempArr[i] = tempArr[index]
              tempArr[index] = temp
          }
      }
      return tempArr
    },
    async getReward () {
      try {
        this.$loading.show()
        let data = await getReward(this.currentReward.reward_id, this.userId)
        if (+data.retcode === 1) {
          sendTraceLog('get_reward', {
            event_name: 'getvip',
            obj_type: 'reward',
            obj_id: this.currentReward.reward_id
          }, this.userId)
          await store.dispatch('updateUserinfo', store.getters.token)
          this.updateRewardDay()
          this.$loading.hide()
          this.maskVisible = true
          this.modalVisible = true
          setTimeout(() => {
            this.hasGetVip = true
          }, 300)
        } else {
          this.openTips('请稍后再试')
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.$loading.hide()
      }
    },
    updateRewardDay () {
      this.rewardDay = {
        text: (this.currentReward.reward_id && (this.currentReward.reward_num2 || this.currentReward.reward_num || '') + '天VIP') || 'VIP',
        visible: true,
        showBefore: false
      }
    },
    // async getRule () {
    //   try {
    //     let data = await getRule(this.rewardId)
    //     this.rewardDay.text = (data.reward.reward_num2 || data.reward.reward_num || '') + '天VIP'
    //     this.rewardDay.visible = true
    //   } catch (e) {
    //     console.error(e)
    //     this.rewardDay.text = 'VIP'
    //     this.rewardDay.visible = true
    //   }
    // },
    goLogin() {
      if (this.userId && this.token) return
      login(window.location.href)
    },
    handleGetVip () {
      if (!this.userId || !this.token) {
        this.goLogin()
        return
      }
      if (this.hasGetVip) {
        this.openTips()
        return
      }
      this.getReward()
    },
    openTips (text = '您已经领取过了哦', duration = 3000) {
      if (this.tips.visible) return
      this.tips = {
        text: text,
        visible: true
      }
      setTimeout(() => {
        this.tips = {
          text: '您已经领取过了哦',
          visible: false
        }
      }, duration)
    },
    goListen () {
      sendTraceLog('listen', {
        event_name: 'getvip'
      }, this.userId)
      this.maskVisible = false
      this.modalVisible = false
      this.$router.push({ path: 'vip' })
    },
    goUserHelp () {
      sendTraceLog('help', {
        event_name: 'getvip'
      }, this.userId)
      this.$router.push({ path: 'helppage', query: { title: '会员问题', id: 'Q1' } })
    },
  },
  computed: {
    ...mapGetters([
      'token',
      'userId',
      'mobile',
      'nickname',
      'avatarUrl',
      'isVip',
      'vipCount',
      'isSub'
    ]),
    vipExpiredDate () {
      return moment().add(this.vipCount, 'd').format('YYYY-MM-DD')
    },
    rewardId () {
      return this.$route.query.reward_id || ''
    },
    loginWay () {
      return this.$route.query.login_way || 'weixin'
    },
    channelId () {
      return this.$route.query.channel_id || 'watch-hd-new'
    }
  },
}
</script>

<style lang="less" scoped>
@import "~@/styles/fn";
.container {
  background: #F4F4F8;
  .header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: .5rem .32rem;
    background-image: linear-gradient(270deg, #F8DD61 0%, #F6CA45 100%);
    background: #FEDC42;
    box-sizing: border-box;
    &-avatar {
      width: 1.12rem;
      height: 1.12rem;
      border: 1px solid #fff;
      box-sizing: border-box;
      border-radius: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &-user {
      margin-left: .24rem;
    }
    &-nickname {
      font-size: .4rem;
      font-weight: bold;
      color: #5B413A;
    }
    &-userid {
      margin-top: .08rem;
      opacity: 0.64;
      font-size: .24rem;
      color: #5B413A;
    }
  }

  .gift {
    padding: .6rem .8rem;
    background: #fff;
    .title {
      font-size: .4rem;
      font-weight: bold;
      color: #604038;
      text-align: center;
    }
    .card {
      margin-top: .32rem;
      position: relative;
      &-text {
        position: absolute;
        font-size: .65rem;
        font-weight: bold;
        color: #fff;
        right: .35rem;
        bottom: .35rem;
        letter-spacing: .04rem;
        // css动画
        // background-image:-webkit-linear-gradient(left,#3498db 0%,#f47920 10%,#d71345 20%,#f7acbc 30%,#ffd400 40%,#3498db 50%,#f47920 60%,#d71345 70%,#f7acbc 80%,#ffd400 90%,#3498db 100%);
        background-image:-webkit-linear-gradient(left, #ffd400 0%, #f59551 25%, #ffd400 50%, #f59551 75%, #ffd400 100%);
        color: transparent;
        background-size: 200% 100%;
        background-clip: text;
        animation: move 8s infinite linear;
        span {
          font-size: .5rem;
        }
      }
      @keyframes move{
        0%{
          background-position:0 0;
        }
        100%{
          background-position:-100% 0;
        }
      }
      img {
        width: 100%;
      }
    }
    .btn {
      margin-top: .3rem;
      img {
        width: 100%;
      }
    }
  }

  .rights {
    padding-top: .2rem;
    background: #fff;
    .title {
      padding: 0 .4rem;
      font-size: .4rem;
      font-weight: bold;
      color: #6C6C73;
    }
  }

  .more-rights {
    padding-top: .24rem;
    padding-bottom: .5rem;
    background: #fff;
    .title {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .all-rights {
        display: inline-flex;
        align-items: center;
        font-size: .28rem;
        color: #a0a0a6;
        .icon-more {
          margin-left: .06rem;
          width: .16rem;
          height: .32rem;
          transform: translateY(.02rem);
        }
      }
    }
    .list {
      padding: 0 .5rem;
      .item {
        display: flex;
        align-items: center;
        margin-bottom: .5rem;
        .pic {
          width: 2.16rem;
        }
        .info {
          flex: 1;
          margin-left: .24rem;
          .item-title {
            margin-bottom: .2rem;
            font-size: .36rem;
            color: #665a57;
          }
          .desc {
            line-height: 1.5;
            color: #a0a0a6;
            font-size: .24rem;
            text-align: justify;
          }
        }
      }
    }
  }

  .qa {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    margin-top: .34rem;
    padding: .28rem .44rem;
    &-text {
      font-size: .3rem;
      color: #6C6C73;
    }
    &-icon {
      width: .2rem;
    }
  }

  .desc {
    padding: .5rem .44rem;
    padding-bottom: 1rem;
    // background: #fff;
    .title {
      margin-bottom: .2rem;
      font-size: 0.4rem;
      font-weight: bold;
      color: #6C6C73;
    }
    .text {
      margin-top: .15rem;
      padding-left: .2rem;
      font-size: .3rem;
      color: #6C6C73;
    }
  }

  .customer {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    padding: .6rem 0;
    &-title {
      width: 52%;
      margin-bottom: .15rem;
      font-size: .28rem;
      color: #A0A0A6;
    }
    &-phone, &-wechat {
      width: 52%;
      display: flex;
      align-items: center;
      margin-bottom: .02rem;
    }
    span {
      margin-left: .14rem;
      font-size: .28rem;
      color: #A0A0A6;
    }
    img {
      width: .32rem;
    }
  }

  .modal {
    min-width: 80%;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: scaleDraw 0.7s ease-in-out;
    padding: 1.84rem .5rem .48rem .5rem;
    background: #fff;
    border-radius: 12px;
    z-index: 100;
    &-pic {
      width: 4.04rem;
      position: absolute;
      top: -1rem;
      left: 50%;
      transform: translateX(-50%);
      img {
        width: 100%;
      }
    }
    &-day {
      position: absolute;
      bottom: .4rem;
      right: .35rem;
      font-size: .4rem;
      font-weight: bold;
      background-image:-webkit-linear-gradient(left, #ffd400 0%, #f59551 25%, #ffd400 50%, #f59551 75%, #ffd400 100%);
      color: transparent;
      background-size: 200% 100%;
      background-clip: text;
      animation: move 8s infinite linear;
    }
    &-title {
      font-size: .4rem;
      font-weight: bold;
      color: #6C6C73;
      text-align: center;
    }
    &-date {
      margin-top: .16rem;
      margin-bottom: .32rem;
      font-size: .28rem;
      color: #C4C4C6;
      text-align: center;
    }
    &-text {
      font-size: .28rem;
      color: #A0A0A5;
      text-align: center;
    }
    &-btn {
      width: 80%;
      margin: 0 auto;
      margin-top: .48rem;
      padding: .24rem .14rem;
      font-size: .34rem;
      font-weight: bold;
      color: #604038;
      text-align: center;
      background: #FEDC42;
      border-radius: 50px;
    }
  }

  .tips {
    z-index: 100;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: scaleDraw 0.7s ease-in-out;
    padding: .2rem .3rem;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.8);
    border-radius: .2rem;
    font-size: .3rem;
    color: #FFF;
    text-align: center;
  }
}

@keyframes scaleDraw {
  0% {
    transform: translate(-50%, -50%) scale(0);
  }
  50% {
    transform: translate(-50%, -50%) scale(1.1);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
}

</style>